// src/pages/IPCensus.js
import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  TextField,
} from "@mui/material";

// Sample data (empty for now)
const rows = []; // Populate with your actual data if available

const columns = [
  "County",
  "LOB",
  "ADMP",
  "Facility",
  "Member ID",
  "Member Name",
  "Member Last Name",
  "Date of Birth",
  "Auth",
  "Center",
  "Adm Call Date",
  "Admit Date",
  "LSTCOVC",
  "Discharge Date",
  "FLAC",
  "Diagnosis Code",
  "Diagnosis Description",
  "New Admit",
  "Type",
];

const IPCensus = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [search, setSearch] = useState("");

  // Filtering rows based on the search query
  const filteredRows = rows.filter((row) =>
    columns.some((col) =>
      row[col]?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  // Handlers for pagination
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Export functionality (stub)
  const handleExportCSV = () => {
    // Implement export logic here
    alert("Export to CSV clicked!");
  };

  return (
    <div style={{ margin: "20px" }}>
      <h2>Current Admissions</h2>
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button variant="contained" color="primary" onClick={handleExportCSV}>
          Export to .csv
        </Button>
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: "200px" }}
        />
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column}>{column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.length > 0 ? (
              filteredRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={index}>
                    {columns.map((column) => (
                      <TableCell key={column}>{row[column]}</TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No data available in table
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>
  );
};

export default IPCensus;
